export default __webpack_public_path__ + "static/media/yamaha.a0058d19.webp";